import { render, staticRenderFns } from "./PersonPicker.vue?vue&type=template&id=6b70fa7b&scoped=true"
import script from "./PersonPicker.vue?vue&type=script&lang=js"
export * from "./PersonPicker.vue?vue&type=script&lang=js"
import style0 from "./PersonPicker.vue?vue&type=style&index=0&id=6b70fa7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b70fa7b",
  null
  
)

export default component.exports